import { Component, Input, OnInit } from '@angular/core';
import { BaseCellStepper } from '../model';
import { NbDialogService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { OfbizFormsService } from '@urbannex/ofbiz-forms';
import { ContentStatusEnum, GridCell, RowCell, Section } from '@urbannex/storethemes';
import { SectionBuilderStoreService } from '../../section-builder-store.service';
import { BaseStepperDirective } from '../base-stepper.directive';

@Component({
  selector: 'kve-hero-image-cell-stepper',
  templateUrl: './hero-image-cell-stepper.component.html',
  styleUrls: ['./hero-image-cell-stepper.component.scss']
})
export class HeroImageCellStepperComponent extends BaseStepperDirective implements OnInit {
  @Input() cell:GridCell | RowCell;
  @Input() section:Section;
  
  constructor(
    ofbizFormsService:OfbizFormsService,
    sectionBuilderStoreService:SectionBuilderStoreService,
    configurationService:ConfigurationService){
    super(ofbizFormsService,sectionBuilderStoreService,configurationService)
  }
  
  ngOnInit(): void {
    console.log(this.cell);
    this.sectionBuilderStoreService.updateSelectedCell(this.cell);
    this.contentEnum = this.cell.contentEnum;
    console.log(this.contentEnum)
    this.stepperTitle = this.getStepperTitle(this.contentEnum)
    this.contentElements = this.cell.contentElements;
    this.baseUrl = this.configurationService.getBaseUrl();
  }

  onSubmitContent(){
      console.log("onSubmitContent",this.section)
      this.cell.status = ContentStatusEnum.CTNT_INITIAL_DRAFT;
      this.section.status = ContentStatusEnum.CTNT_INITIAL_DRAFT;
      this.sectionBuilderStoreService.updateSection(this.section);
      this.sectionBuilderStoreService.updateSelectedCell(this.cell);
      this.closeHostDialog.emit();
    }
}
